// USD-based limits that apply to all currencies
export const MIN_SWAP_AMOUNT_USD = 0.01 // $0.01
export const MAX_SWAP_AMOUNT_USD = 10000 // $10,000

export const AUDIO_TICKER = 'AUDIO'
export const USDC_TICKER = 'USDC'
export const USDC_SYMBOL = 'USD Coin'
